import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Grid,
  Link
} from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReportControl from '../ReportControl/ReportControl';
import { requestTopHospitals, requestReportTopHospitals } from '../../api';
import DHPic from '../../images/Dr-haiel3.png';
import ReportGraph from '../ReportGraph/ReportGraph';
import { Rating } from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';
import { ExpandMore, Info, InfoOutlined } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    maxWidth: 740
  },
  media: {
    height: 300
  },
  avt: {
    marginBottom: 20,
    '&:before': {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: '30px 30px',
      backgroundRepeat: 'no-repeat',
      content: '""',
      position: 'absolute',
      left: 10,
      width: 30,
      height: 30
    }
  },
  bot: {
    maxWidth: 740
  },
  btn: {
    width: '100%',
    backgroundColor: '#1EB0BC',
    opacity: 0.7,
    color: '#fff',
    padding: 15,
    fontSize: '1rem',
    fontWeight: 'bold'
  }
});

const useStyles2 = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1)
  }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ReportCard = ({
  da,
  keyword,
  option,
  onUserInput,
  isLastMessage,
  isSelected,
  chatHistory
}) => {
  option.forEach((element) =>
    console.log('Element in option: ', element.label)
  );
  const classes = useStyles();
  const classes2 = useStyles2();
  const theme = useTheme();
  const [stage, setStage] = React.useState(0);
  /* stage 0 is for  hospital ranking  table, */
  /* stage 1 for the  map view, stage 2 for the pyramid graph */
  const [hospital, setHospital] = React.useState();
  const [hospitalSelected, setHospitalSelected] = React.useState([]);
  const [rating1, setRating1] = React.useState(0);
  const [rating2, setRating2] = React.useState(0);
  const [rating3, setRating3] = React.useState(0);
  const [loot, setloot] = React.useState([]);
  const [top10, setTop10] = React.useState([]);
  const [top10Obj, setTop10Obj] = React.useState([]);
  const [abort, setAbort] = React.useState(false);
  const [hospsConfirmed, setHospsConfirmed] = React.useState(false);
  const [hospsListExpanded, setHospsListExpanded] = React.useState(false);
  const [feedbackConfirmed, setFeedbackConfirmed] = React.useState(false);

  const [loading, setLoading] = React.useState(false);

  const switchStage = (event, newValue) => {
    setStage(newValue);
  };

  const handleChangeIndex = (index) => {
    setStage(index);
  };

  const handleChange = (event) => {
    setHospital(event.target.value);
  };

  const handleSubmit = () => {
    onUserInput('User submit', hospital);
  };

  const handpick = (result) => {
    const lister = [];
    const listerObj = [];
    const len =
      result.topHospList.length >= 10 ? 10 : result.topHospList.length;
    for (let i = 0; i < len; i++) {
      let holder = result.topHospList[i].name;
      holder = holder.concat('(');
      holder = holder.concat(result.topHospList[i].overallSCoreDisplay);
      holder = holder.concat('%');
      holder = holder.concat(')');
      lister.push(holder);
      listerObj.push({ title: holder, score: result.topHospList[i].score });
    }
    console.log('Result is', lister);
    setTop10(lister);
    setTop10Obj(listerObj);
  };

  const extractInformation = async (dkw, da) => {
    console.log('Report Card Reuqest: ', dkw, da);
    // for east 'jump to' debug
    if (!dkw) {
      dkw = 'lung cancer';
      da = 'General';
    }
    if (!abort) {
      setLoading(true);
      let result = [];
      if (da == 'General') {
        console.log('Report Card Reuqest: requestTopHospitals');
        result = await requestTopHospitals(dkw);
      } else {
        console.log('Report Card Reuqest: requestReportTopHospitals');
        result = await requestReportTopHospitals(dkw, da);
      }
      setLoading(false);
      console.log('Already  got the  data', result);
      handpick(result);
      setloot(result);
    } else {
      console.log('Async abort');
    }
  };

  useEffect(() => {
    // Update the document title using the browser API
    console.log('Start extraction');
    extractInformation(keyword, da); // wait for 30 seconds
    if (loot) {
      return;
    } else {
      setTimeout(() => {
        console.log('Wait for the loot to come out!');
      }, 180000);
    }

    console.log('Top hospital is', top10);
  }, []);

  function TabPanel(props) {
    const { propsLoot, value, index } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={index}
        aria-labelledby={index}
      >
        {value === index && <ReportControl loot={propsLoot} value={value} />}
      </div>
    );
  }
  TabPanel.propTypes = {
    propsLoot: PropTypes.object.isRequired,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  };

  console.log('toSave', {
    chatHistory,
    hospitalSelected,
    rating1,
    rating2,
    rating3
  });
  return (
    <Fragment>
      <div className={classes.avt}>_</div>
      <Card
        className={(classes.root, classes.bot)}
        style={{
          marginBottom: '20px',
          backgroundColor: '#E3F5F7'
        }}
      >
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
            style={{ fontSize: '1.25rem' }}
          >
            America's Best Hospitals for {keyword}
          </Typography>

          <Accordion>
            <AccordionSummary
              expandIcon={<InfoOutlined />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                Make expertise of modern medicine known to the world
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box>
                <Typography
                  variant="h5"
                  component="h2"
                  style={{ fontSize: '1rem' }}
                >
                  This mini-report leverage award-winning algorithom to evaluate
                  disease-specific expertise of individual hospitals. So you
                  make more informed decisions about hospital selection, even
                  among the top ones!
                </Typography>
                <ReportGraph />
              </Box>
            </AccordionDetails>
          </Accordion>
        </CardContent>
        <CardActionArea />
        {loading ? (
          <CardContent>
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          </CardContent>
        ) : (
          <CardContent>
            <Box sx={{ backgroundColor: '#fff' }}>
              <AppBar position="static" color="default">
                <Tabs
                  value={stage}
                  onChange={switchStage}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                >
                  <Tab label="Top Rated" value={0} />
                  <Tab label="View Rank" value={1} />
                  <Tab label="View on Map" value={2} />
                  {/* <Tab label="How Selective?" value={4} /> */}
                </Tabs>
              </AppBar>
              <TabPanel
                value={stage}
                index={0}
                dir={theme.direction}
                propsLoot={loot}
              />
              <TabPanel
                value={stage}
                index={1}
                dir={theme.direction}
                propsLoot={loot}
              />
              <TabPanel
                value={stage}
                index={2}
                dir={theme.direction}
                propsLoot={loot}
              />
              {/* <TabPanel
            value={stage}
            index={3}
            dir={theme.direction}
            propsLoot={loot}
          /> */}
            </Box>
          </CardContent>
        )}
        <CardActions style={{ justifyContent: 'center' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                <Link
                  href="https://linkmedicine.com/contact-dr-haiel/"
                  underline="none"
                  variant="inherit"
                  target="_blank"
                  style={{ color: 'white' }}
                >
                  Request More Information
                </Link>
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                <Link
                  href={`https://linkmedicine.com/facts-medical-expertise-analysis/?dkwInput=${keyword}&daInput=${da}`}
                  underline="none"
                  variant="inherit"
                  target="_blank"
                  style={{ color: 'white' }}
                >
                  Access Full report(beta)
                </Link>
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button type="button" className={classes.btn}>
                Seek Navigation Service
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>

      {!loading && (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: '20px',
              backgroundColor: '#E3F5F7'
            }}
          >
            <CardContent>
              <Accordion expanded={hospsListExpanded}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  onClick={() => setHospsListExpanded(!hospsListExpanded)}
                >
                  <Typography className={classes.heading}>
                    What hospital will you choose for your condition?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    {top10Obj.map((item) => (
                      <Fragment>
                        <Checkbox
                          checkedIcon={checkedIcon}
                          disabled={hospsConfirmed}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setHospitalSelected((cur) => {
                                return [...cur, item.title];
                              });
                            } else {
                              setHospitalSelected((cur) => {
                                const afterRemoved = cur.filter(
                                  (itm) => itm != item.title
                                );
                                return [...afterRemoved];
                              });
                            }
                          }}
                        />
                        {item.title}
                        <br />
                      </Fragment>
                    ))}
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Box textAlign="center" p={3}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setHospsConfirmed(true);
                    setHospsListExpanded(false);
                  }}
                  disabled={hospsConfirmed}
                >
                  Confirm
                </Button>
              </Box>
            </CardContent>
            <CardActionArea />
            {/*<FormControl>
               <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              onChange={handleChange}
              defaultValue={hospitalSelected}
              multiple
            >
              <MenuItem>Choose a hospital</MenuItem>
              {top10.map((choice) => (
                <MenuItem value={choice}>{choice}</MenuItem>
              ))}
              <MenuItem value="other hospital">Other hospital</MenuItem>
            </Select> 
              <Autocomplete
                disabled={hospsConfirmed}
                multiple
                id="checkboxes-tags-demo"
                options={top10Obj}
                value={hospitalSelected}
                onChange={(e, v) => setHospitalSelected(v)}
                disableCloseOnSelect
                getOptionLabel={(option) => option.title}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.title}
                  </Fragment>
                )}
                style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Hospitals" />
                )}
              />
            </FormControl>*/}
          </Card>
        </Fragment>
      )}

      {!loading && hospsConfirmed && (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: '20px',
              backgroundColor: '#E3F5F7'
            }}
          >
            <CardContent style={{ fontSize: '1rem' }}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography className={classes.heading}>Feedback</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box>
                    Is the result helpful? <br />
                    <Rating
                      onChange={(e, v) => setRating1(v)}
                      disabled={feedbackConfirmed}
                    />
                    <br />
                    Are you satisfied with the analysis? <br />
                    <Rating
                      onChange={(e, v) => setRating2(v)}
                      disabled={feedbackConfirmed}
                    />
                    <br />
                    Will you recommend this navigation tool to others? <br />
                    <Rating
                      disabled={feedbackConfirmed}
                      onChange={(e, v) => {
                        setRating3(v);
                      }}
                    />
                    <br />
                  </Box>
                </AccordionDetails>
              </Accordion>
              <Box textAlign="center" p={1}>
                <Button
                  variant="contained"
                  onClick={() => {
                    // TODO: toSave goes here
                    setFeedbackConfirmed(true);
                    console.log({
                      chatHistory,
                      hospitalSelected,
                      rating1,
                      rating2,
                      rating3
                    });
                    const res = fetch(
                      'https://lsbotdata-default-rtdb.firebaseio.com/lsbot.json',
                      {
                        method: 'POST',
                        body: JSON.stringify({
                          chatHistory,
                          hospitalSelected,
                          rating1,
                          rating2,
                          rating3
                        }),
                        headers: {
                          'Content-Type': 'application/json'
                        }
                      }
                    );
                  }}
                  disabled={feedbackConfirmed}
                >
                  Confirm
                </Button>
              </Box>
            </CardContent>
            <CardActionArea />
          </Card>
        </Fragment>
      )}

      {!loading && hospsConfirmed && feedbackConfirmed && (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: '20px',
              backgroundColor: '#E3F5F7'
            }}
          >
            <CardContent style={{ fontSize: '1rem' }}>
              Thank you for your feedback.
            </CardContent>
            <CardActionArea />
          </Card>
        </Fragment>
      )}
    </Fragment>
  );
};
ReportCard.propTypes = {
  keyword: PropTypes.string.isRequired,
  option: PropTypes.array.isRequired,
  onUserInput: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool
};
ReportCard.defaultProps = {
  isSelected: false
};

export default ReportCard;



// WEBPACK FOOTER //
// ./src/components/ReportCard/ReportCard.js